import {
  Grid,
  Typography,
  Stack,
  Button,
  IconButton,
  Box,
  Link,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Autocomplete,
  Tooltip,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Divider
} from '@mui/material';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';
import '../StudyLogs.scss';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { useEffect, useState } from 'react';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useTab } from 'src/components/hooks/useTab';
import { setPath } from 'src/store/Navigation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useGetAssigneesMutation } from 'src/services/Utils';
import { setMessage } from 'src/store/Message';
import { useUser } from 'src/components/hooks/useUser';
import { useSqConfirmationLetter } from './useSqConfirmationLetter';
import CloseIcon from '@mui/icons-material/Close';
import { hideLoader, showLoader } from 'src/store/Loader';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { setSQCLDetails } from 'src/store/sqConfirmationLetter';
import { UI_TIME_ZONE } from 'src/constants/formats';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { archLevel } from 'src/data/config';
import { EmailActivity } from '../EmailActivity';
import { useLazyGetEtmfDocDetailsByTmfDocumentIdQuery } from 'src/services/etmfDocLevel';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useValidUserForReAuth } from 'src/components/hooks/useValidUserForReAuth';
import Loader from 'src/components/common/Loader';
import { MainRTE } from '@pihealth/common-ui-library';
import StaticJson from '../../../../resources/static.json';

const pointer = { cursor: 'pointer' };

const SiteQualificationConfirmationLetter: React.FunctionComponent<any> = ({
  siteStudyData,
  setSqConfirmLetterOpen,
  setStudyLogOpen,
  setOpenSQConfLetter,
  setNTFGrid,
  selectedRow
}) => {
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const [approverDetails, setApproverDetails] = useState({
    id: '',
    approver_function: '',
    approver_comment: '',
    sq_visit_id: ''
  });
  const { applicationModuleSection, unSavedWarning } = useFieldTranslation();
  const { selectedAppSection } = useSelectedAppInfo();
  const { getPreferredDateInLocal, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const { checkPermission } = usePermissionWrapper();
  const updateSQCLPermission = checkPermission('update_sq_confirmationletter');
  const approveSQCLPermission = checkPermission('approve_sq_confirmationletter');
  const publishSQCLPermission = checkPermission('publish_sq_confirmationletter');
  const contentEditPermission = checkPermission('edit_content_sq_confirmationletter');
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const sponsor = useAppSelector(state => state.user.user?.sponsor);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const email = useAppSelector(state => state.user.user?.email);
  const role = useAppSelector(state => state.site?.userAccessData.site.resData[0]?.role);
  const { setTabVal, tabsData } = useTab();
  const [salutation, setSalutation] = useState<string>('');
  const [dataFields, setDataFields] = useState<any>([]);
  const [salulationErr, setSalulationErr] = useState(false);
  const [isVersion, setIsVersion] = useState(false);
  const [isEnable, setIsEnable] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [openRTE1, setOpenRTE1] = useState(false);
  const [openRTEContent1, setOpenRTEContent1] = useState(false);
  const [openRTE2, setOpenRTE2] = useState(false);
  const [openRTEContent2, setOpenRTEContent2] = useState(false);
  const [htmlContent1, setHtmlContent1] = useState('');
  const [htmlContent2, setHtmlContent2] = useState('');
  const [disableEditContent1, setDisableEditContent1] = useState(false);
  const [disableEditContent2, setDisableEditContent2] = useState(false);
  const approveSignaturePermission = `APPROVE_SITEQUALIFI_CONFIRMATIONLETTER`;
  const [openConfirmExit, setOpenConfirmExit] = useState(false);
  const [openEmailPopoup, setOpenEmailPopoup] = useState(false);
  const [openVersionPopup, setOpenVersionPopup] = useState(false);
  const staticData = {
    approver_function: null,
    approver_comment: null,
    approved_by: null,
    isNew: true
  };
  const {
    updateSqConfrimationLetter,
    updateSqConfrimationLetterIsLoading,
    updateSqConfrimationLetterIsError,
    updateSqConfrimationLetterError,
    updateSqConfrimationLetterIsSuccess,
    selectSqConfrimationLetter,
    selectSqConfrimationLetterData,
    selectSqConfrimationLetterIsError,
    publishSqConfrimationLetter,
    publishSqConfrimationLetterIsLoading,
    publishSqConfrimationLetterIsError,
    publishSqConfrimationLetterError,
    publishSqConfrimationLetterIsSuccess,
    createNewVersion,
    createNewVersionIsLoading,
    createNewVersionIsError,
    createNewVersionError,
    createNewVersionIsSuccess
  } = useSqConfirmationLetter();
  const dispatch = useAppDispatch();
  const [userList, setUserList] = useState<any[]>([]);
  const { user } = useUser();
  const [
    getUser,
    { data: userData, isError: userDataIsError, isSuccess: userDataIsSuccess, isLoading: userDataIsLoading }
  ] = useGetAssigneesMutation();

  const [getDocumentOnTmfDocumentId, { data: documentOnTmfDocumentIdData }] =
    useLazyGetEtmfDocDetailsByTmfDocumentIdQuery();

  const isUpdatePublish = selectSqConfrimationLetterData?.sq_visit_confirmation?.publish_version_etmf ? true : false;

  const tabList = {
    startUpPacket: 'startUpPacket',
    sqChecklist: 'sqChecklist',
    path: {
      startUpPacket: 'startUpPacket',
      sqChecklist: 'sqChecklist'
    }
  };
  const navigateToTab = (path: string, tabTitle: string) => {
    dispatch(setPath(path));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === tabTitle);
    setTabVal(currentTabinfo[0].index);
  };
  const handelBack = () => {
    if (isChange) {
      setOpenConfirmExit(true);
    } else {
      setSqConfirmLetterOpen(true);
      setStudyLogOpen(false);
      setIsChange(false);
      setNTFGrid(true);
      setOpenSQConfLetter(false);
    }
  };
  const handleSalutaion = (value: any) => {
    setSalutation(value.trimStart());
    setSalulationErr(false);
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  useEffect(() => {
    if (createNewVersionIsLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [createNewVersionIsLoading]);

  useEffect(() => {
    if (!userDataIsLoading && userDataIsError) {
      dispatch(setMessage({ msgDetails: 'Unable to get the users', severity: 'error' }));
    } else if (userData && userDataIsSuccess && !userDataIsLoading) {
      const assignList: any = [];
      userData.map((item: any) =>
        assignList.push({
          key: `${item.first_name} ${item.last_name}`,
          displayName: `${item.first_name} ${item.last_name}`
        })
      );
      setUserList(assignList);
    }
  }, [userData, userDataIsLoading, userDataIsError]);

  const usersList: any = [];
  userList.filter(data => {
    const isDuplicate = usersList.includes(data.displayName);
    if (!isDuplicate) {
      usersList.push(data.displayName);
      return true;
    }
    return false;
  });

  useEffect(() => {
    getUser({
      client_name: 'ctms-ui',
      data: [approveSignaturePermission]
    });
    getSqConfrimationLetterData();
  }, []);

  const handleAdd = () => {
    setDataFields([...dataFields, { ...staticData, id: dataFields.length }]);
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleChangeSingle = (event: any, values: any, id?: any) => {
    setDataFields(
      dataFields.map((ele: any) => {
        if (ele.id === id) {
          return { ...ele, approver_function: values };
        } else {
          return ele;
        }
      })
    );
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleComment = (e: any, id?: any) => {
    const value = e.target.value;
    const commentAdded = dataFields.map((ele: any) => {
      if (ele.id === id) {
        return { ...ele, approver_comment: value };
      } else {
        return ele;
      }
    });
    setDataFields(commentAdded);
    setIsChange(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleClose = (row: any) => {
    const filtered = dataFields.filter((ele: any) => ele.id !== row.id);
    setDataFields(filtered);
    setConfirmExitValue(dispatch, true);
  };

  const getSqConfrimationLetterData = async () => {
    await selectSqConfrimationLetter({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      sq_visit_id: selectedRow?.id
    });
  };

  useEffect(() => {
    if (selectSqConfrimationLetterData) {
      const tempData = selectSqConfrimationLetterData?.sq_comments?.map((elem: any) => {
        if (elem.approver_comment === null) {
          return {
            approver_function: elem.approver_function,
            approver_comment: elem.approver_comment,
            approved_by: elem.approved_by,
            approver_role: elem.approver_role,
            approver_email: elem.approver_email,
            approved_datetime: elem.approved_datetime,
            id: elem.id,
            sq_visit_id: elem.sq_visit_id,
            reason: elem.reason,
            needtoupdate: true
          };
        } else {
          return {
            approver_function: elem.approver_function,
            approver_comment: elem.approver_comment,
            approved_by: elem.approved_by,
            approver_role: elem.approver_role,
            approver_email: elem.approver_email,
            approved_datetime: elem.approved_datetime,
            id: elem.id,
            sq_visit_id: elem.sq_visit_id,
            reason: elem.reason
          };
        }
      });
      if (tempData.length) {
        setIsEnable(true);
      }
      setDataFields(tempData);
      setSalutation(selectSqConfrimationLetterData?.sq_visit_confirmation?.salutation_letter);
    }
    dispatch(setSQCLDetails(selectSqConfrimationLetterData?.sq_visit_confirmation));
    dispatch(hideLoader());
  }, [selectSqConfrimationLetterData]);

  useEffect(() => {
    if (selectSqConfrimationLetterData?.sq_visit_confirmation?.is_published_etmf) {
      setIsVersion(true);
    } else {
      setIsVersion(false);
    }
  }, [selectSqConfrimationLetterData]);

  const validationOfRTE1 =
    selectSqConfrimationLetterData?.sq_visit_confirmation?.sqc_rte1 === '' ||
    selectSqConfrimationLetterData?.sq_visit_confirmation?.sqc_rte1 === null
      ? StaticJson.SQconfirmationLetterRTE1
      : selectSqConfrimationLetterData?.sq_visit_confirmation?.sqc_rte1;
  const validationOfRTE2 =
    selectSqConfrimationLetterData?.sq_visit_confirmation?.sqc_rte2 === '' ||
    selectSqConfrimationLetterData?.sq_visit_confirmation?.sqc_rte2 === null
      ? StaticJson.SQconfirmationLetterRTE2
      : selectSqConfrimationLetterData?.sq_visit_confirmation?.sqc_rte2;

  const approverName = selectSqConfrimationLetterData?.sq_comments?.filter((obj: any) => {
    return obj.approver_function === user;
  });

  const approverCondition = approverName?.length > 0 ? approverName[0].approver_function !== user : true;

  const handleSaveSQCL = async () => {
    const newUserData = dataFields.filter((ele: any) => ele.isNew && ele.approver_function !== null);
    if (salutation) {
      const payload = {
        sq_visit_id: selectedRow?.id,
        sq_confirmation: {
          visit_scheduled_date: new Date(selectedRow?.start_date),
          salutation_letter: salutation.trim(),
          sq_confirmation_sponsor_name: sponsor,
          sq_confirmation_publish_version: 0,
          tp_document_meta_id: selectedRow?.id,
          tp_document_id: 'string',
          is_published_etmf: false,
          sqc_rte1: htmlContent1 === '' ? validationOfRTE1 : htmlContent1,
          sqc_rte2: htmlContent2 === '' ? validationOfRTE2 : htmlContent2
        },
        sq_issues: newUserData,
        updated_by: user
      };
      updateSqConfrimationLetter({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        data: payload
      });
    } else {
      setSalulationErr(true);
    }
    setConfirmExitValue(dispatch, false);
  };

  const handleSignApproval = async (row: any) => {
    setOpenSignConsent(true);
    setApproverDetails({
      ...approverDetails,
      id: row.id,
      sq_visit_id: row.sq_visit_id,
      approver_function: row.approver_function,
      approver_comment: row.approver_comment
    });
  };

  const printSQCL = async () => {
    try {
      dispatch(showLoader());
      const options = {
        sq_visit_id: selectedRow?.id,
        template_name: 'Site_qualification_Confirmation',
        study_id: studyId,
        site_id: selectedSite,
        pathVariables: {
          time_zone_id: UI_TIME_ZONE,
          country: selectedCountry,
          appName: `${archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP}`
        }
      };
      printPdfWithViewer('get_sqconfirmationletter_pdf_file', options, 'application/pdf');
      setTimeout(() => {
        dispatch(hideLoader());
      }, 1500);
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
    setConfirmExitValue(dispatch, false);
  };

  const approvedBy = selectSqConfrimationLetterData?.sq_comments?.length
    ? selectSqConfrimationLetterData?.sq_comments
        ?.map((elem: any) => elem.approved_by)
        .some((elem: any) => elem === null)
    : true;

  const handlePublishSQCL = async () => {
    if (publishSQCLPermission) {
      try {
        dispatch(showLoader());
        await publishSqConfrimationLetter({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          sq_visit_id: selectedRow?.id,
          time_zone_id: UI_TIME_ZONE,
          publish_doc_version:
            selectSqConfrimationLetterData?.sq_visit_confirmation?.publish_version_etmf >= 1
              ? Math.floor(selectSqConfrimationLetterData?.sq_visit_confirmation?.publish_version_etmf + 1)
              : '1.0',
          is_published_etmf: true,
          update: isUpdatePublish
        });
        dispatch(hideLoader());
        await getSqConfrimationLetterData();
      } catch (error: any) {
        dispatch(hideLoader());
        if (error && error?.response?.status === 403) {
          dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
        } else if (error && error.response?.status === 401) {
          dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
        } else {
          dispatch(setMessage({ msgDetails: 'Error while publishing', severity: 'error' }));
        }
      }
    }
    setConfirmExitValue(dispatch, false);
  };

  const handleEmailActivity = () => {
    setOpenEmailPopoup(true);
  };

  useEffect(() => {
    if (updateSqConfrimationLetterIsError || publishSqConfrimationLetterIsError || createNewVersionIsError) {
      const err: any = updateSqConfrimationLetterError || publishSqConfrimationLetterError || createNewVersionError;
      if (err?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${err?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (err?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      } else if (err?.status == 404) {
        dispatch(
          setMessage({
            msgDetails: 'Error',
            severity: 'error'
          })
        );
      }
    }
    dispatch(hideLoader());
  }, [
    selectSqConfrimationLetterIsError,
    updateSqConfrimationLetterIsError,
    publishSqConfrimationLetterIsError,
    createNewVersionIsError
  ]);

  useEffect(() => {
    if (publishSqConfrimationLetterIsSuccess && !publishSqConfrimationLetterIsLoading) {
      dispatch(
        setMessage({
          msgDetails: 'Successfully published to ETMF',
          severity: 'success'
        })
      );
    }
  }, [publishSqConfrimationLetterIsSuccess, publishSqConfrimationLetterIsLoading]);

  useEffect(() => {
    if (updateSqConfrimationLetterIsSuccess && !updateSqConfrimationLetterIsLoading) {
      dispatch(
        setMessage({
          msgDetails: 'Data updated successfully',
          severity: 'success'
        })
      );
      getSqConfrimationLetterData();
      setOpenRTEContent1(false);
      setOpenRTEContent2(false);
      setDisableEditContent1(false);
      setDisableEditContent2(false);
      setIsChange(false);
    }
  }, [updateSqConfrimationLetterIsSuccess, updateSqConfrimationLetterIsLoading]);

  useEffect(() => {
    if (createNewVersionIsSuccess) {
      dispatch(hideLoader());
      dispatch(
        setMessage({
          msgDetails: 'New site qualification confirmation letter version ready to modify.',
          severity: 'success'
        })
      );
      setOpenVersionPopup(false);
      getSqConfrimationLetterData();
      setOpenRTEContent1(false);
      setOpenRTEContent2(false);
      setDisableEditContent1(false);
      setDisableEditContent2(false);
      setIsChange(false);
      setIsEnable(false);
    }
  }, [createNewVersionIsSuccess]);

  useEffect(() => {
    if (selectSqConfrimationLetterData?.sq_visit_confirmation?.tp_document_id_etmf) {
      getDocumentBasedTmfDocumentId(selectSqConfrimationLetterData?.sq_visit_confirmation?.tp_document_id_etmf);
    }
  }, [selectSqConfrimationLetterData?.sq_visit_confirmation?.tp_document_id_etmf]);

  useEffect(() => {
    if (
      selectSqConfrimationLetterData?.sq_comments &&
      Array.isArray(selectSqConfrimationLetterData?.sq_comments) &&
      selectSqConfrimationLetterData?.sq_comments?.length
    ) {
      setDisableEditContent1(true);
      setDisableEditContent2(true);
    }
  }, [selectSqConfrimationLetterData]);

  const getDocumentBasedTmfDocumentId = async (tpDocumentId: string) => {
    await getDocumentOnTmfDocumentId({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      tmfDocumentId: tpDocumentId,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      module_section_related: 'STUDY LOGS',
      parent_entity_related: selectedRow?.visit_name
    });
  };

  const dateTime = getPreferredDateTimeInLocal(selectedRow?.start_date)?.split(' ');
  const date = dateTime[0];
  const time = dateTime[1];
  const meridiem = dateTime[2];
  const [setESignature] = useLazySetESignQuery();
  const handleSQApproverSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        const dataObj = {
          username: data.records.user_name,
          password: data.records.password,
          module_name: applicationModuleSection.sqConfirmationLetter,
          name_of_signature: 'approved_by',
          name_of_date_field: 'approved_datetime',
          id: approverDetails.id,
          columns_to_change: {
            reason: data.records.sign_reason,
            approver_function: approverDetails.approver_function,
            approver_comment: approverDetails.approver_comment,
            approver_role: role,
            approver_email: email,
            updated_by: user
          },
          columns_to_filter: { sq_visit_id: approverDetails.sq_visit_id }
        };
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.studyLogs,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          await getSqConfrimationLetterData();
          setConfirmExitValue(dispatch, false);
          setIsChange(false);
          dispatch(setMessage({ msgDetails: 'Sign Successful', severity: 'success' }));
        } else if (signatureResponse.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        setApproverDetails({
          id: '',
          approver_function: '',
          approver_comment: '',
          sq_visit_id: ''
        });
        dispatch(hideLoader());
      }
    }
  };
  const handelChangeTextEditor = (htmlContext: any, planetext: any, e: any) => {
    e === 'SQconfirmationLetterRTE1' ? setHtmlContent1(htmlContext) : setHtmlContent2(htmlContext);
  };
  const handleEditRTE = (content: string) => {
    switch (content) {
      case 'content1':
        setOpenRTE1(true);
        setOpenRTEContent1(true);
        break;
      case 'content2':
        setOpenRTE2(true);
        setOpenRTEContent2(true);
        break;
    }
  };
  const handleSaveRTE = (content: string) => {
    switch (content) {
      case 'content1':
        setOpenRTE1(false);
        setDisableEditContent1(true);
        setIsChange(true);
        break;
      case 'content2':
        setOpenRTE2(false);
        setDisableEditContent2(true);
        setIsChange(true);
        break;
    }
  };

  const handleCreateNewVersion = () => {
    setOpenVersionPopup(true);
  };

  const handleCreateNewversion = () => {
    createNewVersion({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP,
      sq_visit_id: selectedRow?.id,
      application_section: selectedAppSection
    });
  };

  return (
    <>
      <Loader />
      <Box className="mainBackBtnWrap" sx={{ mt: -1 }}>
        <Button onClick={handelBack} startIcon={<ArrowBackIcon fontSize="small" />}>
          SQ Confirmation List
        </Button>
      </Box>
      <Grid container spacing={1} sx={{ mb: 1.5, alignItems: 'center' }}>
        <Grid item>
          <Typography variant="h5" component="h5" sx={{ margin: 0, fontSize: '20px', fontWeight: 500 }}>
            {selectedRow?.visit_name}
          </Typography>
        </Grid>
        <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Stack direction="row" spacing={1.5}>
            {archLevel === 'sponsor' && (
              <Button
                variant="contained"
                style={{ textTransform: 'none' }}
                sx={{ alignSelf: 'center' }}
                disabled={isVersion || !(publishSQCLPermission && !approvedBy)}
                onClick={() => handlePublishSQCL()}
              >
                PUBLISH TO eTMF
              </Button>
            )}
            {archLevel === 'sponsor' && (
              <Button
                sx={{ alignSelf: 'center' }}
                disabled={
                  !checkPermission('create_new_version_sq_confirmation_letter') ||
                  selectSqConfrimationLetterData?.sq_visit_confirmation?.is_published_etmf !== true
                }
                onClick={handleCreateNewVersion}
              >
                Create new version
              </Button>
            )}
            {archLevel === 'sponsor' && (
              <Button
                sx={{ alignSelf: 'center' }}
                onClick={() => handleSaveSQCL()}
                disabled={
                  (!updateSQCLPermission && !selectedRow?.start_date) || !salutation || !isChange || isVersion
                    ? true
                    : (!approveSQCLPermission && !selectedRow?.start_date) || !salutation || !isChange
                    ? true
                    : false
                }
              >
                Save
              </Button>
            )}
            <IconButton
              aria-label="Print"
              color="primary"
              sx={{ alignSelf: 'center' }}
              onClick={() => printSQCL()}
              disabled={!selectSqConfrimationLetterData?.sq_visit_confirmation?.is_published_etmf}
            >
              <LocalPrintshopIcon />
            </IconButton>
            {archLevel === 'sponsor' && (
              <IconButton
                aria-label="Send"
                color="primary"
                sx={{ alignSelf: 'center' }}
                onClick={() => handleEmailActivity()}
                disabled={
                  !checkPermission('email_sponsor_site_qualification_confirmation_letter') ||
                  !selectSqConfrimationLetterData?.sq_visit_confirmation?.is_published_etmf
                }
              >
                <SendIcon />
              </IconButton>
            )}
          </Stack>
        </Grid>
      </Grid>

      <Box className="letterPage">
        <Typography gutterBottom color="text.secondary2">
          {getPreferredDateInLocal(selectedRow?.start_date)} <br />
          {siteStudyData?.pi_first_name} {siteStudyData?.pi_last_name} <br />
          {siteStudyData?.site_name} <br />
          {siteStudyData?.site_street_address1} {siteStudyData?.site_street_address2} <br />
          {siteStudyData?.site_city}, {siteStudyData?.site_state}, {siteStudyData?.site_zip_code}
        </Typography>
        <dl className="text-Bold dlStyle">
          <dt>RE:</dt>
          <dd>
            {siteStudyData?.study_id}-{siteStudyData?.study_title} <br />
            Site Qualification Confirmation for Protocol {siteStudyData?.study_id} <br />
            Site Number: {siteStudyData?.site_id}
          </dd>
        </dl>
        <Typography sx={{ mb: 1, pt: 2 }}>
          Dear &nbsp;{' '}
          <span style={{ width: '220px', display: 'inline-block' }}>
            <TextField
              id="salutationField"
              label="Salutation"
              required
              inputProps={{ maxLength: 50 }}
              placeholder="Salutation"
              variant="standard"
              className="salutationField"
              value={salutation?.trimStart() || ''}
              onChange={(e: any) => handleSalutaion(e.target.value)}
              error={salulationErr}
              disabled={selectSqConfrimationLetterData?.sq_comments?.length > 0 || !updateSQCLPermission || isVersion}
              sx={{ mt: '-16px !important' }}
            />
          </span>
          {siteStudyData?.pi_first_name} {siteStudyData?.pi_last_name}
          , <br />
        </Typography>
        <Typography gutterBottom>
          Thank you for your interest in the above-mentioned study. Please accept this letter as confirmation of our{' '}
          {selectedRow?.sub_type} Site Qualification Visit scheduled for {date} at {time} {meridiem}
        </Typography>
        {contentEditPermission &&
        selectSqConfrimationLetterData?.sq_visit_confirmation?.is_published_etmf !== true &&
        approverCondition ? (
          <Paper variant="outlined" sx={{ position: 'relative', my: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: 1.5, px: 2 }}>
              <Typography variant="subtitle1">Editable Content</Typography>
              {openRTE1 ? (
                <Button variant="contained" size="small" color="primary" onClick={() => handleSaveRTE('content1')}>
                  SAVE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={disableEditContent1}
                  onClick={() => handleEditRTE('content1')}
                >
                  EDIT
                </Button>
              )}
            </Box>
            <Divider variant="middle" sx={{ mx: 0 }} />
            <Box className="editRTEBox" p={2}>
              {openRTEContent1 ? (
                <MainRTE
                  log={(htmlContext: any, planetext: any) =>
                    handelChangeTextEditor(htmlContext, planetext, 'SQconfirmationLetterRTE1')
                  }
                  value={validationOfRTE1}
                  placeholder={'Enter Value'}
                  height={400}
                  disabled={disableEditContent1}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: validationOfRTE1
                  }}
                />
              )}
            </Box>
          </Paper>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: validationOfRTE1
            }}
          />
        )}
        Please find enclosed with this letter the following documents:
        <ul>
          <li>
            A copy of the current draft{' '}
            <Link
              onClick={() => navigateToTab(tabList.path.startUpPacket, tabList.startUpPacket)}
              style={pointer}
              underline="always"
            >
              protocol/synopsis
            </Link>{' '}
            has been uploaded
          </li>
          <li>
            <Link
              onClick={() => navigateToTab(tabList.path.sqChecklist, tabList.sqChecklist)}
              style={pointer}
              underline="always"
            >
              Site Qualification checklist
            </Link>{' '}
            [incl version/date].
          </li>
          <li>
            <Link>Electronic Medical Records (EMR) Evaluation Form</Link>
          </li>
        </ul>
        {contentEditPermission &&
        selectSqConfrimationLetterData?.sq_visit_confirmation?.is_published_etmf !== true &&
        approverCondition ? (
          <Paper variant="outlined" sx={{ position: 'relative', my: 2 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ py: 1.5, px: 2 }}>
              <Typography variant="subtitle1">Editable Content</Typography>
              {openRTE2 ? (
                <Button variant="contained" size="small" color="primary" onClick={() => handleSaveRTE('content2')}>
                  SAVE
                </Button>
              ) : (
                <Button
                  variant="contained"
                  size="small"
                  color="primary"
                  disabled={disableEditContent2}
                  onClick={() => handleEditRTE('content2')}
                >
                  EDIT
                </Button>
              )}
            </Box>
            <Divider variant="middle" sx={{ mx: 0 }} />
            <Box p={2}>
              {openRTEContent2 ? (
                <MainRTE
                  log={(htmlContext: any, planetext: any) =>
                    handelChangeTextEditor(htmlContext, planetext, 'SQconfirmationLetterRTE2')
                  }
                  value={validationOfRTE2}
                  placeholder={'Enter Value'}
                  height={200}
                  disabled={disableEditContent2}
                />
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html: validationOfRTE2
                  }}
                />
              )}
            </Box>
          </Paper>
        ) : (
          <div
            dangerouslySetInnerHTML={{
              __html: validationOfRTE2
            }}
          />
        )}
        <Typography gutterBottom>
          I look forward to meeting with you and your staff. In the meantime, should you have any questions, please do
          not hesitate to contact me using the details at the foot of this letter.
        </Typography>
        <Typography gutterBottom>
          Yours sincerely, <br />
          {user} <br />
          <span color="text.secondary">{sponsor?.toUpperCase()}</span>
        </Typography>
      </Box>

      <Box sx={{ pt: 2 }}>
        <Grid container>
          <Grid md={12}>
            <TableContainer
              className="studylog-table"
              sx={{ border: '1px solid rgba(0,0,0,0.12)', maxHeight: '280px' }}
            >
              <Table aria-label="collapsible table" className="table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Approver Function</TableCell>
                    <TableCell>Approver Comment</TableCell>
                    <TableCell>Approved by</TableCell>
                    <TableCell>Approved Date</TableCell>
                    <TableCell width={44} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataFields.map((row: any, index: number) => (
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={index}>
                      <TableCell>
                        {row.isNew ? (
                          <Autocomplete
                            disabled={!updateSQCLPermission}
                            id="tags-standard"
                            options={usersList}
                            getOptionLabel={(option: any) => option}
                            renderInput={params => (
                              <TextField {...params} variant="standard" label="User" placeholder="User" />
                            )}
                            onChange={(e, values) => handleChangeSingle(e, values, row.id)}
                          />
                        ) : (
                          <>{row.approver_function}</>
                        )}
                      </TableCell>
                      <TableCell>
                        {row.isNew || row.needtoupdate ? (
                          <TextField
                            id="salutationField"
                            placeholder="Comment"
                            variant="standard"
                            className="salutationField"
                            value={row.approver_comment}
                            onChange={(e: any) => handleComment(e, row.id)}
                            disabled={
                              row.isNew ||
                              row.approved_by !== null ||
                              !(approveSQCLPermission && row.approver_function === user)
                            }
                            style={{ marginTop: '11px' }}
                          />
                        ) : (
                          <>{row.approver_comment}</>
                        )}
                      </TableCell>
                      <TableCell>
                        {row.isNew || row.approved_by === null ? (
                          <Button
                            size="small"
                            variant="contained"
                            onClick={() => handleSignApproval(row)}
                            disabled={row.isNew || !(approveSQCLPermission && row.approver_function === user)}
                          >
                            Sign
                          </Button>
                        ) : (
                          <span className="signedInfo">
                            Signed by <strong>{row.approved_by}</strong>
                            <br />
                            on <span color="text.secondary">
                              {getPreferredDateTimeInLocal(row.approved_datetime)}
                            </span>{' '}
                            <br />
                            <span className="signReasonrow">
                              <span color="text.secondary">Reason:</span> &ldquo;
                              {row.reason}
                              &rdquo;
                            </span>
                            <br />
                            <i>({row.approver_email})</i>
                            <br />
                            <span color="text.secondary">({row.approver_role})</span>
                          </span>
                        )}
                      </TableCell>
                      <TableCell>
                        {row?.approved_datetime ? getPreferredDateTimeInLocal(row?.approved_datetime) : ''}
                      </TableCell>
                      <TableCell>
                        {row.isNew ? (
                          <Tooltip title="Remove" placement="top">
                            <IconButton onClick={() => handleClose(row)}>
                              <CloseIcon />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <></>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
      <Button
        sx={{ mt: 1.5 }}
        startIcon={<AddIcon />}
        onClick={() => handleAdd()}
        disabled={!updateSQCLPermission || isEnable || isVersion}
      >
        Add
      </Button>
      <PopupComponent
        open={openConfirmExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="confirm-modal"
        child
      >
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenConfirmExit(false);
            }}
            className="grey-btn"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              setSqConfirmLetterOpen(true);
              setStudyLogOpen(false);
              setIsChange(false);
              setNTFGrid(true);
              setOpenSQConfLetter(false);
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </PopupComponent>
      {openEmailPopoup && (
        <EmailActivity
          openEmailPopoup={openEmailPopoup}
          setOpenEmailPopoup={setOpenEmailPopoup}
          documentDetails={documentOnTmfDocumentIdData}
          permission={'UPDATE_SITEQUALIFI_CONFIRMATIONLETTER'}
        />
      )}
      <PopupComponent aria-labelledby="customized-dialog-title" open={openVersionPopup} maxWidth="lg">
        <DialogTitle> Please Confirm</DialogTitle>
        <DialogContent>
          <Typography variant="body1">Are you sure you want to create a new version?</Typography>
        </DialogContent>
        <DialogActions>
          <Button className="grey-btn" onClick={() => setOpenVersionPopup(!openVersionPopup)}>
            Cancel
          </Button>
          <Button onClick={handleCreateNewversion}>Create</Button>
        </DialogActions>
      </PopupComponent>
      {openSignConsent && (
        <ESignConsentReAuth
          openSignConsent={openSignConsent}
          setOpenSignConsent={setOpenSignConsent}
          handleConfirmSign={handleSQApproverSign}
        />
      )}
    </>
  );
};

export default SiteQualificationConfirmationLetter;
